import "./Start.css";
import { ArrowRight } from "iconsax-react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { url } from "../../config/constant";
import { getAuth, signOut } from "firebase/auth";
function Start() {
  useEffect(() => {
    async function checkLogin() {
      await getAuth().onAuthStateChanged(async (user) => {
        if (user) {
          await fetch(`${url}/user/${user.phoneNumber}`).then(async (res) => {
            const body = await res.json();
            if (res.status === 200) {
              return (window.location = "/home");
            }
          });
        }
      });
    }
    checkLogin();
  }, []);
  return (
    <>
      <div className="body">
        <div className="body-photo">
          <div className="image"></div>
        </div>

        <div className="content">
          <div className="first">
            <span className="blue">Share</span>
            <span>Me</span>
          </div>
          <div className="second">
            <span>Share your books to those who really need it.</span>
          </div>
          <br />
          <br />
          <center>
            <Link to="/mobile" className="icon">
              <ArrowRight size="32" color="white" />
            </Link>
          </center>
        </div>
      </div>
    </>
  );
}

export default Start;
